import React, { useEffect, useState } from "react";

import { Modal, Select } from "antd";
import { ErrorMessage, Field, Form, Formik } from "formik";
import InputMask from "react-input-mask";

import { CompanyParams } from "../../../Context/companyContext";
import api from "../../../services/api";
import designSystemColors from "../../../styles";
import { notifyError, notifySucces } from "../../../utils/notifications";
import * as S from "../../creditCard/style";
import InputCard from "../../InputCard";
import LoadingElevaty from "../../LoadingElevaty";
import editDependentSchema from "./schema";
import { ContainerSelect, ModalRowWrap } from "./styles";

const { Option } = Select;

export const ModalEditDependant = ({
  open,
  closeModal,
  dependent,
  grauParentesco,
  setUpdateDepedents,
  client,
}) => {
  const [dependente, setDependente] = useState({
    cpf: "",
    dataNascimento: "",
    grauParentesco: "",
    nome: "",
    nomeMae: "",
    sexo: "",
  });

  const [contato, setContato] = useState({
    faturaDigital: "",
    receberSMS: "",
    tipo: "",
    ramal: "",
    area: "",
    telefone: "",
  });

  const [loading, setLoading] = useState(false);
  const { companyParams } = CompanyParams();

  useEffect(() => {
    if (dependent) {
      setDependente({
        cpf: dependent.cpf || "",
        dataNascimento:
          dependent.dataNascimento.split("-").reverse().join("-") || "",
        grauParentesco: grauParentesco[dependent.idGrauParentesco] || "",
        nome: dependent.nome || "",
        nomeMae: dependent.nomeMae || "",
        sexo:
          dependent.sexo === "M" || dependent?.sexo === "MASCULINO"
            ? "MASCULINO"
            : "FEMININO" || "",
      });

      setContato({
        faturaDigital: "",
        receberSMS: "",
        tipo: "",
        ramal: "",
        area: dependent.areaTelefone || "",
        telefone: dependent.numeroTelefone || "",
      });
    }
  }, [dependent, grauParentesco]);

  const handleChangeTitular = (event) => {
    const { id, value } = event.target;
    setDependente((prev) => ({ ...prev, [id]: value }));
  };

  const handleChangeContato = (event) => {
    const { id, value } = event.target;
    setContato((prev) => ({ ...prev, [id]: value }));
  };

  const handleChangeSelectTitular = (value, field, setFieldValue) => {
    setFieldValue(field, value);
    setDependente((prev) => ({ ...prev, [field]: value }));
  };
  const editDependent = async (value) => {
    try {
      setLoading(true);
      const formatedDate = value.dataNascimento.replace(/\//g, "-");
      const data = {
        cpf: `${value.cpf.split(".").join("").replace("-", "")}`,
        dataNascimento: formatedDate.split("-").reverse().join("-"),
        grauParentesco: `${value.grauParentesco}`,
        nome: value?.nome,
        nomeMae: value.nomeMae,
        sexo:
          value?.sexo === "M" || value?.sexo === "MASCULINO"
            ? "MASCULINO"
            : "FEMININO",
        telefone: {
          faturaDigital: "false",
          receberSMS: "false",
          area: `${value.area}`,
          telefone: `${value.telefone.replace("_", "")}`,
          tipo: "CELULAR",
        },
      };
      await api.patch("client_dependent", {
        dependent_id: dependent.id,
        client_id: client.client.id,
        ...data,
      });
      closeModal();
      notifySucces("Dependente editado com sucesso");
    } catch (error) {
      const stringError = error.message;
      notifyError(stringError);
    } finally {
      setLoading(false);
      setUpdateDepedents();
    }
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "");
    if (digits.length >= 9) {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
    }
    return digits;
  };
  return (
    <Modal title="Editar Dependente" visible={open} onCancel={closeModal}>
      {loading && (
        <S.NewLoadingModals>
          <LoadingElevaty width="40px" height="40px" duration="durFast" />
        </S.NewLoadingModals>
      )}
      <h1>Informações Dependente</h1>
      <Formik
        enableReinitialize
        initialValues={{
          nome: dependent?.nome || "",
          dataNascimento:
            dependent?.dataNascimento.split("-").reverse().join("-") || "",
          cpf: dependent?.cpf || "",
          sexo:
            dependent?.sexo || dependent?.sexo === "MASCULINO"
              ? "MASCULINO"
              : "FEMININO" || "",
          grauParentesco: grauParentesco[dependent?.idGrauParentesco] || "",
          nomeMae: dependent?.nomeMae || "",
          area: dependent?.areaTelefone || "",
          telefone: formatPhoneNumber(dependent?.numeroTelefone || ""),
        }}
        validationSchema={editDependentSchema}
        onSubmit={(values, { setSubmitting, resetForm }) =>
          editDependent(values, resetForm)
        }
      >
        {({ setFieldValue, values, isValid }) => (
          <Form>
            <S.ModalAddWrapper>
              <S.ModalRowWrap>
                <Field name="nome">
                  {({ field, meta }) => (
                    <InputCard
                      addonBefore="Nome"
                      placeholder="Nome"
                      maskChar=""
                      maxLength={79}
                      onChange={handleChangeTitular}
                      className={meta.touched && meta.error ? "error-id" : null}
                      requiredInfo
                      {...field}
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="nome"
                  component="div"
                  className="error-message"
                />
              </S.ModalRowWrap>
              <S.ModalRowWrap>
                <S.inputW50>
                  <Field name="dataNascimento">
                    {({ field, meta }) => (
                      <InputCard
                        value={dependente.dataNascimento}
                        addonBefore="Nascimento"
                        placeholder="dd/mm/yyyy"
                        mask="99/99/9999"
                        maskChar=""
                        onChange={handleChangeTitular}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="dataNascimento"
                    component="div"
                    className="error-message"
                  />
                </S.inputW50>
                <S.inputW50>
                  <Field name="cpf">
                    {({ field, meta }) => (
                      <InputCard
                        value={dependente.cpf}
                        addonBefore="CPF"
                        mask="999.999.999-99"
                        maskChar=""
                        placeholder="999.999.999-99"
                        maxLength={80}
                        onChange={handleChangeTitular}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        disabled
                        style={{
                          cursor: "not-allowed",
                          backgroundColor: "#f5f5f5",
                          color: "#000",
                        }}
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="cpf"
                    component="div"
                    className="error-message"
                  />
                </S.inputW50>
              </S.ModalRowWrap>
              <ModalRowWrap>
                <ContainerSelect>
                  <p className="title">
                    <span
                      style={{
                        color: "#ff4d4f",
                      }}
                    >
                      *{" "}
                    </span>
                    Sexo
                  </p>
                  <Field name="sexo">
                    {({ field, meta }) => (
                      <Select
                        defaultValue={values.sexo}
                        value={values.sexo}
                        maskChar={null}
                        {...field}
                        id="sexo"
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        onChange={(value) => {
                          handleChangeSelectTitular(
                            value,
                            "sexo",
                            setFieldValue
                          );
                        }}
                      >
                        <Option value="">Sexo</Option>
                        <Option value="MASCULINO">Masculino</Option>
                        <Option value="FEMININO">Feminino</Option>
                      </Select>
                    )}
                  </Field>
                  <ErrorMessage
                    name="sexo"
                    component="div"
                    className="error-message"
                  />
                </ContainerSelect>
                <ContainerSelect>
                  <p className="title">
                    <span
                      style={{
                        color: "#ff4d4f",
                      }}
                    >
                      *{" "}
                    </span>
                    Grau Parentesco
                  </p>
                  <Field name="grauParentesco">
                    {({ field, meta }) => (
                      <Select
                        value={values.grauParentesco}
                        maskChar={null}
                        {...field}
                        id="grauParentesco"
                        onChange={(value) => {
                          handleChangeSelectTitular(
                            value,
                            "grauParentesco",
                            setFieldValue
                          );
                        }}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                      >
                        <Option value="">Grau de parentesco</Option>
                        <Option value="PAI">Pai</Option>
                        <Option value="MAE">Mãe</Option>
                        <Option value="FILHO">Filho</Option>
                        <Option value="IRMAO">Irmão</Option>
                        <Option value="CONJUGE">Conjuge</Option>
                        {!companyParams?.name
                          ?.toLowerCase()
                          ?.includes("lopes") && (
                          <Option value="OUTROS">Outros</Option>
                        )}
                      </Select>
                    )}
                  </Field>
                  <ErrorMessage
                    name="grauParentesco"
                    component="div"
                    className="error-message"
                  />
                </ContainerSelect>
              </ModalRowWrap>
              <S.ModalRowWrap>
                <Field name="nomeMae">
                  {({ field, meta }) => (
                    <InputCard
                      value={dependente.nomeMae}
                      addonBefore="Nome da Mãe"
                      placeholder="Nome da mãe"
                      maxLength={79}
                      maskChar=""
                      onChange={handleChangeTitular}
                      className={meta.touched && meta.error ? "error-id" : null}
                      requiredInfo
                      {...field}
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="nomeMae"
                  component="div"
                  className="error-message"
                />
              </S.ModalRowWrap>
              <S.ModalRowWrap>
                <S.inputW50>
                  <Field name="area">
                    {({ field, meta }) => (
                      <InputCard
                        id="area"
                        value={contato.area}
                        addonBefore="DDD"
                        placeholder="DDD"
                        mask="99"
                        maskChar=""
                        onChange={handleChangeContato}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="area"
                    component="div"
                    className="error-message"
                  />
                </S.inputW50>
                <S.inputW50>
                  <Field name="telefone">
                    {({ field, meta, form }) => (
                      <InputCard
                        id="telefone"
                        value={form.values.telefone || ""}
                        addonBefore="Telefone"
                        mask="99999-9999"
                        maskChar=""
                        maxLength={10}
                        placeholder="99999-9999"
                        onChange={(e) => {
                          const formatted = formatPhoneNumber(e.target.value);
                          form.setFieldValue("telefone", formatted);
                        }}
                        className={meta.touched && meta.error ? "error-id" : ""}
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="telefone"
                    component="div"
                    className="error-message"
                  />
                </S.inputW50>
              </S.ModalRowWrap>
            </S.ModalAddWrapper>
            <S.ModalRow>
              <div
                className="center"
                style={{
                  marginTop: "1rem",
                }}
              >
                {!loading && (
                  <div className="btns-send center">
                    <button
                      type="submit"
                      style={{
                        backgroundColor: isValid
                          ? designSystemColors.generalButtons
                          : "#D3D3D3",
                        color: "#FFFFFF",
                        borderRadius: "0.5rem",
                        fontWeight: "500",
                        cursor: !isValid && "not-allowed",
                      }}
                      disabled={!isValid}
                    >
                      Editar dependente
                    </button>
                  </div>
                )}
              </div>
            </S.ModalRow>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
